import api from './api';

export interface Trigger {
  id: string;
  workflowId: string;
  token: string;
  hookUrl: string;
  enabled: boolean;
  lastTriggeredAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const triggersService = {
  async list(): Promise<Trigger[]> {
    const response = await api.get<Trigger[]>('/triggers');
    return response.data;
  },
  async create(workflowId: string): Promise<Trigger> {
    const response = await api.post<Trigger>('/triggers', { workflowId });
    return response.data;
  },
  async setEnabled(id: string, enabled: boolean): Promise<Trigger> {
    const response = await api.patch<Trigger>(`/triggers/${id}`, { enabled });
    return response.data;
  },
  async rotate(id: string): Promise<Trigger> {
    const response = await api.post<Trigger>(`/triggers/${id}/rotate`);
    return response.data;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/triggers/${id}`);
  },
};
